export default __webpack_public_path__ + "static/media/icon-gift-solid.6a05fc87.svg";